// Libs
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import { Box, Tab } from '@mui/material';
// Components, Layouts, Pages
import ChildrenPage from '~/pages/common/childrenPage/ChildrenPage';
import { BaseTabList } from '~/components/common';
import { MaterialInformationTemplate } from '~/pages/template';
// Others
import { adminRouteAbsolute } from '~/utils/routes/admin';
import { staffRouteAbsolute } from '~/utils/routes/staff';
import { IBaseTabItem } from '~/utils/interface/common';
import { EMPTY_STRING } from '~/utils/constants/common';
import { MaterialDetailTabsEnum, RoleEnum } from '~/utils/enum/common';
import { StorageEnum } from '~/utils/enum/base';
// Styles, images, icons
import styles from './MaterialDetail.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const MaterialDetail = (props: Props) => {
  //#region Destructuring Props

  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/material', 'common/base']);
  const { hash } = useLocation();
  const navigate = useNavigate();
  const { id: materialId } = useParams();

  const getMenuItems = useCallback(() => {
    const items: Array<IBaseTabItem> = [
      { label: MaterialDetailTabsEnum.INFORMATION, component: <MaterialInformationTemplate /> },
    ];

    setTabItems(items);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [materialId]);

  const currentRole: string = localStorage.getItem(StorageEnum.ROLE) ?? EMPTY_STRING;
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [tabKey, setTabKey] = useState<string>('information');
  const [tabItems, setTabItems] = useState<IBaseTabItem[]>([]);
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  useEffect(() => {
    if (hash) setTabKey(hash.slice(1));
  }, [hash]);

  useEffect(() => {
    getMenuItems();
  }, [getMenuItems]);
  //#endregion Implement Hook

  //#region Handle Function
  const handleBackToCustomers = () => {
    switch (currentRole) {
      case RoleEnum.ADMIN:
        navigate(adminRouteAbsolute.materials);
        break;

      case RoleEnum.STAFF:
        navigate(staffRouteAbsolute.materials);
        break;
    }
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    navigate(`#${newValue}`);
  };

  const renderTabContent = () => {
    const item = tabItems.find((tabItem: IBaseTabItem) => {
      return tabKey === tabItem.label;
    });

    return item?.component;
  };
  //#endregion Handle Function

  return (
    <ChildrenPage
      id='materialDetailPage'
      title={t('material_detail_title')}
      onBackToPreviousPage={handleBackToCustomers}
    >
      <>
        <BaseTabList value={tabKey} onChange={handleTabChange}>
          {tabItems.map((item, index) => (
            <Tab
              value={item.label}
              key={index}
              label={t(`tab_label_${item.label}`)}
              className={cx('tabItem')}
            />
          ))}
        </BaseTabList>

        <Box component={'div'} className={cx('tabContent')}>
          {renderTabContent()}
        </Box>
      </>
    </ChildrenPage>
  );
};

export default MaterialDetail;
